"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _operators = require("rxjs/operators");

var _ajax = require("rxjs/ajax");

var _ActionsSocket = _interopRequireDefault(require("../../../dist/client/ActionsSocket"));

var _fromActionSocket = _interopRequireDefault(require("./fromActionSocket"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var fromSyncedSessionActionSocket = function fromSyncedSessionActionSocket() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var actionsHost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var actionsSocketNamespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return (0, _ajax.ajax)({
    url: url,
    withCredentials: true,
    crossDomain: true,
    createXHR: function createXHR() {
      return new XMLHttpRequest();
    }
  }).pipe((0, _operators.retryWhen)(function (errors) {
    return errors.pipe((0, _operators.delay)(1000));
  }), (0, _operators.take)(1), (0, _operators.switchMap)(function () {
    return (0, _fromActionSocket["default"])((0, _ActionsSocket["default"])(actionsHost, actionsSocketNamespace));
  }));
};

var _default = fromSyncedSessionActionSocket;
exports["default"] = _default;